
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ServicesOverviewSection from './components/ServicesOverviewSection';
import ProjectExperienceSection from './components/ProjectExperienceSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="HP Inc Consultant Services - Leading Safety Consulting Firm in New York"
        description="Professional safety consulting services including OSHA compliance, industrial hygiene, safety staffing, training, and coating inspection. Serving New York's construction and industrial sectors with expert safety solutions."
        keywords="safety consulting New York, OSHA compliance consulting, industrial hygiene services, safety staffing solutions, OSHA training programs, coating inspection services, workplace safety consultants, construction safety, industrial safety experts"
        canonical="https://hpincconsultant.com/"
        ogTitle="HP Inc Consultant Services - Professional Safety Consulting"
        ogDescription="Leading safety consulting firm providing comprehensive OSHA compliance, industrial hygiene, safety staffing, and training services in New York."
        ogUrl="https://hpincconsultant.com/"
      />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ServicesOverviewSection />
        <ProjectExperienceSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
